"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react")); // tslint:disable-next-line:variable-name


exports.ScriptRenderer = function (_a) {
  var src = _a.src,
      functionInvocationString = _a.functionInvocationString,
      id = _a.id,
      async = _a.async;

  var handleLoadScript = function handleLoadScript() {
    try {
      // tslint:disable-next-line:no-function-constructor-with-string-args
      functionInvocationString && new Function(functionInvocationString)();
    } catch (e) {
      console.log(e);
    }
  };

  var handleFailLoad = function handleFailLoad() {
    console.log(src + " failed to load");
  };

  var generateAndAppendScriptTag = function generateAndAppendScriptTag() {
    // tslint:disable-next-line:one-variable-per-declaration
    var body = document.getElementsByTagName("body")[0],
        scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.async = async || false;
    scriptTag.src = src;
    body.appendChild(scriptTag);
    scriptTag.addEventListener("load", handleLoadScript);
    scriptTag.addEventListener("error", handleFailLoad);
  };

  React.useEffect(function () {
    return generateAndAppendScriptTag();
  }, []);
  return id ? React.createElement("div", {
    id: id
  }) : null;
};